import UserStore from '@/store/user'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const userStore = UserStore()
  const { currentUser } = storeToRefs(userStore)

  if (currentUser.value) {
    if (!currentUser.value.isRegistered && !(to.name as string ?? '').includes('app-onboarding')) return { name: 'app-onboarding' }
  } else {
    return { name: 'app-auth', query: to.query ?? {} }
  }
})